module.exports = __webpack_public_path__ + "media/images/salon-frame-68d7792434ee2957be698ffbac8fc837.jpg";